 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }import {mergeAttributes, Node} from '@tiptap/core'








// An inline token that renders `label` and reveals a TipTap document in a hover popover.
export const PopoverMentionBase = Node.create({
  name: 'popoverMention',

  group: 'inline',
  inline: true,
  atom: true,
  selectable: false,

  addAttributes() {
    return {
      label: {
        default: '',
        parseHTML: (el) => _nullishCoalesce(el.getAttribute('data-label'), () => ( '')),
        renderHTML: (attrs) => ({'data-label': attrs.label})
      },
      content: {
        default: ''
      }
    }
  },

  parseHTML() {
    return [{tag: `span[data-type="${this.name}"]`}]
  },

  renderHTML({HTMLAttributes, node}) {
    return [
      'span',
      mergeAttributes({'data-type': this.name}, HTMLAttributes),
      (node.attrs ).label
    ]
  },

  renderText({node}) {
    return (node.attrs ).label
  }
})
